import { handleCreateReviewError } from '../utils';

export const handleSubmitError = (error) => {
  console.error(error);
  const { message } = error;

  let code;
  if (message.includes('429')) {
    code = 429;
  } else if (message.includes('409')) {
    code = 409;
  } else if (message.includes('403')) {
    code = 403;
  }

  handleCreateReviewError(code);
};
